/**
 * 睡眠のある日を横に並べ、タップで切り替える
 */

import { useEffect, useRef } from 'react'

import type { SleepDaySummary } from '@/api/types/sleep'
import { cn } from '@/lib/utils'

import { formatDay, formatMinutes } from '../format'

type Props = {
  days: SleepDaySummary[]
  selectedDate: string | null
  onSelect: (date: string) => void
}

export const DayStrip = ({ days, selectedDate, onSelect }: Props) => {
  const selectedRef = useRef<HTMLButtonElement | null>(null)

  useEffect(() => {
    selectedRef.current?.scrollIntoView({ block: 'nearest', inline: 'center' })
  }, [selectedDate])

  return (
    <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1">
      {days.map((d) => {
        const selected = d.date === selectedDate
        return (
          <button
            key={d.date}
            ref={selected ? selectedRef : undefined}
            type="button"
            onClick={() => onSelect(d.date)}
            className={cn(
              'flex shrink-0 flex-col items-start rounded-lg border px-3 py-2 text-left',
              selected ? 'border-indigo-500 bg-indigo-500/10' : 'bg-card',
            )}
          >
            <span className="text-[11px] text-muted-foreground">{formatDay(d.date)}</span>
            <span className="text-sm font-semibold tabular-nums">{formatMinutes(d.total_min)}</span>
            <span className="text-[11px] text-muted-foreground tabular-nums">
              {d.episode_count > 1 ? `${d.episode_count}回` : d.score !== null ? `スコア ${d.score}` : ' '}
            </span>
          </button>
        )
      })}
    </div>
  )
}
